export const formatHtmlText = (htmlText = '') => (
	htmlText.replace(
		/<(\/?(b|br|em|p|s|strong|u))>/gi,
		(matched, record) => `[[${record}]]`,
	)
);

export const parseHtmlText = (formattedHtmlText = '') => (
	formattedHtmlText.replace(
		/\[\[(\/?(b|br|em|p|s|strong|u))\]\]/gi,
		(matched, record) => `<${record}>`,
	)
);
